<script setup>
import { defineProps, computed} from "vue";
import LinhaDeItemDeItem from "./LinhaDeItemDeItem.vue";

//==================================================================//
//========================= Props & Emits ==========================//
//==================================================================//

const props = defineProps([
    "dado",
    "item",
]);

//==================================================================//
//========================= Itens de Item ==========================//
//==================================================================//

let itensDeItemHeaders = [
    { text: 'Sequência',           value: 'sequencia'},
    { text: 'Descrição',           value: 'descricao'},
    { text: 'Quantidade',          value: 'quantidade'},
    { text: 'Valor Unitário',      value: 'valorUnitario'},
    { text: 'Valor Total',         value: 'valorTotal'},
    { text: '',                    value: 'espaco'},
]

</script>

<template>

    <div class="c-table-wrapper">

        <div class="c-table">

            <div class="c-table__headers">

                <div class="c-table__header" v-for="itemDeItemHeader in itensDeItemHeaders"
                    :key="itemDeItemHeader.value"
                >

                    <div class="c-table__header-content">

                        {{itemDeItemHeader.text}}

                    </div>
                    
                </div>

            </div>
            <div class="c-table__body">

                <LinhaDeItemDeItem v-for="itemDeItem in props?.item?.itens"
                    :key="itemDeItem.id"
                    :dado="props?.dado"
                    :item="props?.item"
                    :itemDeItem="itemDeItem"
                ></LinhaDeItemDeItem>

            </div>

        </div>

    </div>

</template>

<style scoped>

.c-table-wrapper{
    overflow: hidden !important;
    padding: 12px 12px 12px 12px !important;
}

.c-table{
    background: #ffffff;
    display: grid;
    grid-template-columns: max-content max-content max-content max-content max-content auto;
    overflow: auto;
    border-bottom: thin solid rgba(0, 0, 0, 0.12);
    box-shadow: rgba(0, 0, 0, 0.12) 0px 1px 3px, rgba(0, 0, 0, 0.24) 0px 1px 2px;
    border-radius: 5px;
}

.c-table__headers{
    display: contents;
    color: rgba(0, 0, 0, 0.6);
    font-size: 0.75rem;
}

.c-table__header{
    padding: 14px 16px;
    border-bottom: thin solid rgba(0, 0, 0, 0.12);
    font-weight: 700;
    background-color: #dedede;
    color: #363636;
}

.c-table__body{
    display: contents;
}

</style>
